<template>
    <header>
        <div class="logo" @click="redirectToHome">
            <img
                src="@/assets/customizer_dreamytales_profile_logo.svg"
                width="80"
                height="80"
                alt="DreamyTales Logo"
            />
        </div>

    </header>
</template>

<script>
export default {
    name: "CustomizerHeader",
    methods: {
        redirectToHome() {
            window.location.href = "/";
        },
    },
};
</script>

<style lang="scss" scoped>
@use "@/assets/customizer.vars.scss" as *;
header {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    column-gap: 16px;
    width: 100%;
    max-width: 1128px;
    padding: 20px 16px;
    margin: 0 auto;

    @media (max-width: $breakpoint-mobile) {
        justify-content: center;
        padding: 15px 0;
    }

    .logo {
        margin: 0px 0;
        cursor: pointer;

        @media (max-width: $breakpoint-mobile) {
            margin: 0;
        }

        img {
            @media (max-width: $breakpoint-mobile) {
                width: 60px;
                height: auto;
            }
        }
    }


}
</style>
